import { rootStore } from 'cv-react-core';

const getTheme = () => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    // Populate the component parts with theme styles
    return {
        indicator: {
            color: theme.statusLoadingIndicatorColor,
        },

        indicatorContainer: {
        },

        modal: {
            backgroundColor: theme.statusLoadingBackgroundColor,
            shadowColor: theme.modalShadowColor,
        },

        overlay: {
        },

        text: {
            ...theme.fonts.loadingStatusMajor,
        },

        textContainer: {
        },
    };
};

export default getTheme;
